import NewHero from './NewHero';

export default NewHero;
